'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { textColorValues } from "../../atomic/colors.css.js";
import { hasContrast } from "./hasContrast.js";
const getOnActionColor = (backgroundColor, foregroundColor, alternativeForegroundColor) => {
  if (hasContrast(backgroundColor, foregroundColor)) {
    return foregroundColor;
  }
  if (alternativeForegroundColor && hasContrast(backgroundColor, alternativeForegroundColor)) {
    return alternativeForegroundColor;
  }
  if (hasContrast(backgroundColor, textColorValues["onLight.text.primary"])) {
    return textColorValues["onLight.text.primary"];
  }
  if (hasContrast(backgroundColor, textColorValues["onDark.text.primary"])) {
    return textColorValues["onDark.text.primary"];
  }
  return tinycolor.mostReadable(backgroundColor, [
    textColorValues["onLight.text.primary"],
    textColorValues["onDark.text.primary"]
  ]).toHexString();
};
export {
  getOnActionColor
};
